module.exports = __webpack_public_path__ + "img/media_tem_3.cee5629a.png";